import MeasureDto from './MeasureDto';

export default class MeasureDataPreviewDto
  extends MeasureDto {
  constructor(options = {}) {
    super(options);
    this.fields = options.fieldDefinitions ? options.fieldDefinitions.fields : null;
  }
} 
